// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getTopShortenedTasks(projectId: string, startDate: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/top_shortened_tasks${startDate ? `?start_date=${startDate}` : ''}`);
}
